<template>
    <div class="flex w-full flex-col items-center gap-10 max-w-3xl">
        <div class="text-center leading-tight">
            <h2 class="max-w-2xl display-medium text-balance mb-2">
                <span class="text-ink">{{ t("onboarding.evaluator.enableContextGuide.title") }}</span>
            </h2>
            <p class="text-ink-muted body md:display-serif max-w-xl mx-auto text-pretty">{{ t("onboarding.evaluator.enableContextGuide.subtitle") }}</p>
        </div>

        <!-- Action cards -->
        <div class="flex flex-col gap-4 w-full">
            <BaseCard v-for="item in actionItems" :key="item.title" class="flex items-start gap-4">
                <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-surface-sunken text-ink-muted">
                    <i :class="`bi ${item.icon} text-lg`" aria-hidden="true"></i>
                </div>
                <div class="flex-1 min-w-0">
                    <h3 class="body-small-bold text-ink mb-1">{{ item.title }}</h3>
                    <p class="body-small text-ink-muted mb-3">{{ item.description }}</p>
                    <BaseChip size="xs" class="whitespace-normal text-ink-muted">
                        <i :class="`bi ${item.ctaIcon} text-sm`" aria-hidden="true"></i>
                        {{ item.cta }}
                    </BaseChip>
                </div>
            </BaseCard>
        </div>

        <div class="flex items-center gap-4 mt-2">
            <BaseButton theme="tertiary" @click="emit('back')"> <i class="bi bi-arrow-left mr-1" aria-hidden="true"></i> {{ t("onboarding.evaluator.shared.back") }} </BaseButton>
            <BaseButton theme="primary" class="w-60" @click="emit('start')"> {{ t("onboarding.evaluator.enableContextGuide.startJourney") }} </BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import BaseChip from "~vue/components/BaseChip.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emit = defineEmits<{
    back: [];
    start: [];
}>();

const actionItems = computed(() => [
    {
        title: t("onboarding.evaluator.enableContextGuide.items.calendar.title"),
        icon: "bi-calendar-week",
        description: t("onboarding.evaluator.enableContextGuide.items.calendar.description"),
        cta: t("onboarding.evaluator.enableContextGuide.items.calendar.cta"),
        ctaIcon: "bi-shield-lock",
    },
    {
        title: t("onboarding.evaluator.enableContextGuide.items.collaborationProfiles.title"),
        icon: "bi-people-fill",
        description: t("onboarding.evaluator.enableContextGuide.items.collaborationProfiles.description"),
        cta: t("onboarding.evaluator.enableContextGuide.items.talkToEngagementManager"),
        ctaIcon: "bi-chat-dots",
    },
    {
        title: t("onboarding.evaluator.enableContextGuide.items.organizationContext.title"),
        icon: "bi-building",
        description: t("onboarding.evaluator.enableContextGuide.items.organizationContext.description"),
        cta: t("onboarding.evaluator.enableContextGuide.items.talkToEngagementManager"),
        ctaIcon: "bi-chat-dots",
    },
]);
</script>
